module.exports = __webpack_public_path__ + "static/media/tyrell_token.488cb5f0.png";